import type { TranslationStatus, TranslationTarget } from "./translation-status"
import { getLanguageByCode } from "@/screens/settings/settings-pages/language-selector"

interface TranslationRow {
	language: string
	translationStatus?: TranslationStatus
	updatedAt?: number | null
}

export function buildTranslationTargets<Row extends TranslationRow>({
	enabledLanguages,
	defaultLanguage,
	translations,
	hasContent,
}: {
	enabledLanguages: readonly string[]
	defaultLanguage: string
	translations: readonly Row[] | undefined
	hasContent: (row: Row | undefined) => boolean
}): TranslationTarget[] {
	return [...new Set(enabledLanguages)]
		.filter((code) => code !== defaultLanguage)
		.map((code) => {
			const row = translations?.find((t) => t.language === code)
			return {
				code,
				name: getLanguageByCode(code)?.name ?? code,
				translationStatus: row?.translationStatus ?? null,
				updatedAt: row?.updatedAt ?? null,
				hasExistingContent: hasContent(row),
			}
		})
}

export function formatLanguageList(names: readonly string[]): string {
	if (names.length <= 1) return names[0] ?? ""
	return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`
}
